import { render, staticRenderFns } from "./wxjd_sxgk.vue?vue&type=template&id=49111c67&scoped=true"
import script from "./wxjd_sxgk.vue?vue&type=script&lang=js"
export * from "./wxjd_sxgk.vue?vue&type=script&lang=js"
import style0 from "./wxjd_sxgk.vue?vue&type=style&index=0&id=49111c67&prod&scoped=scoped&lang=css"
import style1 from "./wxjd_sxgk.vue?vue&type=style&index=1&id=49111c67&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49111c67",
  null
  
)

export default component.exports